module.exports = __webpack_public_path__ + "img/cyp.d069616c.svg";